export const NUVEMPAGO_TRANSPARENT_CHECKOUT_IN_ADVANCED_SETTINGS_FEATURE_FLAG =
  'fs-nuvempago-set-transparent-checkout-in-advanced-settings';
